import { Injectable, inject, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { rxResource } from '@angular/core/rxjs-interop';

interface HealthResponse {
  status: string;
  version: string;
  database: string;
  sha: string;
}

@Injectable({ providedIn: 'root' })
export class AppHealthService {
  private readonly http = inject(HttpClient);

  private readonly healthResource = rxResource<HealthResponse, void>({
    stream: () => this.http.get<HealthResponse>('/api/health'),
  });

  readonly isHealthy = computed(() => this.healthResource.value()?.status === 'ok');
  readonly version = computed(() => this.healthResource.value()?.version ?? null);
}
